var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.2485C4.00387 16.4732 4.06926 16.6925 4.18905 16.8827C4.30884 17.0728 4.47846 17.2265 4.67946 17.327C4.88018 17.4404 5.10681 17.5 5.33736 17.5C5.5679 17.5 5.79453 17.4404 5.99525 17.327L15.3244 11.5569C15.5274 11.4592 15.6986 11.3061 15.8185 11.1153C15.9384 10.9245 16.0019 10.7037 16.0019 10.4784C16.0019 10.2531 15.9384 10.0324 15.8185 9.84159C15.6986 9.6508 15.5274 9.49771 15.3244 9.39992L5.99525 3.67301C5.79453 3.5596 5.5679 3.5 5.33736 3.5C5.10681 3.5 4.88018 3.5596 4.67946 3.67301C4.47846 3.77352 4.30884 3.92719 4.18905 4.11734C4.06926 4.30748 4.00387 4.52682 4 4.75152V16.2485Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/playVideo.4ab0d7d8cdc7c91823c15bfc33bd8736.svg";
export { ForwardRef as ReactComponent };